// extracted by mini-css-extract-plugin
export var Button = "index-module--Button--85e16";
export var ButtonWrapper = "index-module--ButtonWrapper--d577f";
export var Container = "index-module--Container--a4952";
export var IconWrapper = "index-module--IconWrapper--9f06c";
export var LogoutButton = "index-module--LogoutButton--382b0";
export var LogoutWrapper = "index-module--LogoutWrapper--2b907";
export var Subtitle = "index-module--Subtitle--e92c3";
export var Title = "index-module--Title--13861";
export var UserEmail = "index-module--UserEmail--a603f";
export var UserIcon = "index-module--UserIcon--2e754";
export var UserName = "index-module--UserName--eaaa1";
export var fadeIn = "index-module--fadeIn--dd9e9";
export var iconFadeIn = "index-module--iconFadeIn--222ad";